export default __webpack_public_path__ + "static/media/kneeSagittalMovement.00087911.png";